import { ToolResult } from '../../types';
import { CountertopMaterial, CountertopMaterialOptionsResult } from '../../../countertop-material/countertop-material.class';

export const getCountertopMaterialOptionsTool = (): ToolResult<CountertopMaterialOptionsResult> => {
	const result = CountertopMaterial.getOptions();

	return {
		success: true,
		message: `Found ${result.options.length} countertop material options.`,
		data: result
	};
};
